module.exports = __webpack_public_path__ + "img/salveaza_datele.ed75192c.svg";